import { shareGoal } from "@assets";
import { ShareGoalModal } from "@components/Goals/ShareGoalModal";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title4 } from "@components/Typography";
import { useErrorBanner, useGoalsContext, useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";
import { ShareGoalProps } from "./types";

export const ShareGoalCard = ({ style }: ShareGoalProps) => {
  const styles = useStyles();

  const { goalId } = useGoalsContext();

  const { showErrorBanner } = useErrorBanner();
  const { show } = useModal();

  const onClick = () => {
    if (!goalId) return showErrorBanner();

    show(<ShareGoalModal goalId={goalId} />);
  };

  return (
    <div style={{ ...styles.container, ...style }} onClick={onClick}>
      <img src={shareGoal} alt="Share Goal" />
      <Spacing size={SpacingSizes.XXXS} />

      <Title4 style={styles.title}>{i18n.t(Translations.ShareGoalCardTitle)}</Title4>
      <Spacing size={SpacingSizes.XXXS} />

      <Body style={styles.subtitle}>{i18n.t(Translations.ShareGoalCardSubtitle)}</Body>
    </div>
  );
};
